// biome-ignore-all lint: external api
// @ts-nocheck

let webchat;
((window, document, node, props, configs) => {
  if (window.TalkdeskChatSDK) {
    console.error('TalkdeskChatSDK already included');
    return;
  }
  const divContainer = document.createElement('div');
  divContainer.id = node;
  document.body.appendChild(divContainer);
  const src = 'https://talkdeskchatsdk.talkdeskapp.com/talkdeskchatsdk.js';
  const script = document.createElement('script');
  const firstScriptTag = document.getElementsByTagName('script')[0];
  script.type = 'text/javascript';
  script.id = 'tdwebchatscript';
  script.src = src;
  script.async = true;
  firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
  script.onload = () => {
    webchat = TalkdeskChatSDK(node, props);
    webchat.init(configs);
  };
})(
  window,
  document,
  'tdWebchat',
  { touchpointId: '928eb2b35d2842fb9d74ec96afef9bda', accountId: '', region: 'td-us-1' },
  { enableValidation: false, enableEmoji: true, enableUserInput: true, enableAttachments: true },
);
